export default __webpack_public_path__ + "static/media/678.041ec3e4.gif";